/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../common/app-shared.module';
import {SignInPageComponent} from './sign-in-page.component';
import {SignInModalComponent} from './sign-in-modal.component';

@NgModule({
  imports: [AppSharedModule, FormsModule, UIRouterModule],
  declarations: [SignInPageComponent, SignInModalComponent],
  exports: [SignInPageComponent, SignInModalComponent]
})
export class SignInModule {
}
